<!----
    Author: hjlee
    Description:
        트리
---->
<template>
  <div v-if="!slaveEvent || masterSelectedRow" :class="{'tree-container': true, 'show-tree': isTreeShown, 'no-show-tree': !isTreeShown}">
    <div
      v-if="masterEvent"
      :class="{'disable-list-background': true, 'disabled': (slaveMode === 'create') || (slaveMode === 'update')}"
      v-html="$t('common.notification.slave_item_editing', { master_item: $t('item.nm.' + item), slave_item: $t('item.nm.' + slaveItem) })"
    />
    <div v-if="!developing" :class="{'working': mode === 'create' || mode === 'update'}">
      <div class="card tree-form">
        <div class="card-header">
          <i class="fa fa-list" /> {{ $t('item.nm.' + item) }} <span> - {{ $t('common.label.list') }} </span>
          <b-button class="open-tree-button" variant="light" @click="toggleTree()">
            <i class="fa fa-align-right" />
          </b-button>
        </div>
        <div v-if="!isBusy" class="card-body show">
          <input style="display:none" type="text" name="faketextremembered" autofocus="true">
          <input style="display:none" type="password" name="fakepasswordremembered">
          <div class="navigation">
            <b-container class="button-area">
              <b-button variant="light" @click="reload">
                <i class="fa fa-refresh" />
              </b-button>
              <b-button v-if="hasAuthority('create_' + item)" variant="light" @click="addChild($event)">
                <i class="fa fa-plus" />
              </b-button>
              <b-button v-if="hasAuthority('delete_' + item) && deletable" variant="light" :disabled="!(selectedNode && selectedNode.checked && selectedNode.checked.length > 0)" @click="deleteRows()">
                <i class="fa fa-trash-o" />
              </b-button>
              <b-button class="close-tree-button" variant="light" @click="toggleTree()">
                <i class="fa fa-angle-double-left" />
              </b-button>
            </b-container>
            <div class="navigation-filter">
              <input style="display:none" type="text" name="faketextremembered" autofocus="true">
              <input style="display:none" type="password" name="fakepasswordremembered">
              <input v-model="treeFilter" type="text" :placeholder="$t('common.placeholder.filter')">
            </div>
            <div class="navigation-tree">
              <liquor-tree
                ref="tree"
                v-model="selectedNode"
                :data="rows"
                :options="treeOptions"
                :filter="treeFilter"
                @node:dragging:finish="onDragFinish"
                @node:selected="onNodeSelected"
              >
                <div slot-scope="{ node }" v-b-tooltip="true" class="tree-scope" :title="node.text + ( node.data._subtitle ? (' - ' + node.data._subtitle) : '')">
                  <template>
                    <span :class="{'text': true, 'inactive': node.data.updatableTreeData.sttusCode && (node.data.updatableTreeData.sttusCode !== 'menu_status.active')}">
                      {{ node.text }}
                      <span v-if="node.data.updatableTreeData.sttusCode && node.data.updatableTreeData.sttusCode.endsWith('.inactive')" class="inactive-badge">({{ $t('common.text.disabled') }})</span>
                    </span>

                    <span v-if="node.data && node.data._subtitle" class="subtitle">
                      {{ node.data._subtitle }}
                    </span>
                    <span v-if="hasAuthority('create_' + item)" @click="addChild($event, node)">
                      <i class="fa fa-plus" />
                    </span>
                  </template>
                </div>
              </liquor-tree>
            </div>
          </div>
          <div class="content">
            <item-detail
              v-if="updateTargetNode && getSelectedFirstNode() && isNewInserted(updateTargetNode)"
              :module="module"
              :infos="infos"
              :columns="insertColumns"
              action="insert"
              :item="item"
              :row="updateTargetNode"
              :visible-data="updateTargetNode"
              :node-depth="selectedNodeDepth"
              :master-selected-row="masterSelectedRow"
              class="content-inner"
              @forceUpdate="onForceUpdate()"
            />
            <item-detail
              v-else-if="updateTargetNode && getSelectedFirstNode() && !isNewInserted(updateTargetNode)"
              :module="module"
              :infos="infos"
              :columns="updateColumns"
              action="update"
              :item="item"
              :row="updateTargetNode"
              :visible-data="updateTargetNode"
              :node-depth="selectedNodeDepth"
              :master-selected-row="masterSelectedRow"
              class="content-inner"
              @forceUpdate="onForceUpdate()"
            />
            <div v-else v-html="$t('common.text.no_selected_tree_node')" />
          </div>
        </div>
      </div>
      <div class="form-actions">
        <button v-if="hasAuthority('update_' + item) && updatable" :disabled="!isUpdatable()" class="btn btn-primary" type="button" @click="updateConfirm">
          {{ $t('common.button.save') }}
        </button>
      </div>
    </div>
    <b-modal
      id="cancel-update-confirm-modal"
      ref="exitUpdateConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="load"
    >
      <p class="my-4" v-html="$t('common.modal.text.updated_confirm')" />
    </b-modal>
    <b-modal
      id="update-confirm-modal"
      ref="updateConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="update"
    >
      <p class="my-4" v-html="$t('common.modal.text.update_confirm')" />
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    module: {
      type: String,
      required: true
    },
    item: {
      type: String,
      required: true
    },
    slaveItem: {
      type: String,
      default: undefined
    },
    masterEvent: {
      type: String,
      default: undefined
    },
    slaveEvent: {
      type: String,
      default: undefined
    },
    dontCheckAuthor: {
      type: Boolean,
      default: false
    },
    treeUrl: {
      type: String,
      default: undefined
    },
    updateTreeUrl: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      developing: false,
      rows: [],
      deletedRows: [],
      initRows: undefined,
      detailColumns: [], // 상세용 컬럼 목록
      insertColumns: [], // 입력용 컬럼 목록
      updateColumns: [], // 수정용 컬럼 목록
      totalColumns: [], // 전체 컬럼 목록
      updateTargetNode: undefined,
      isBusy: false,
      mode: 'list',
      lastResponse: undefined,
      selectedNode: undefined,
      keyColumns: [],
      slaveMode: 'list',
      scrollToMe: false,
      treeFilter: '',
      treeOptions: {},
      orderable: false,
      deletable: false,
      updatable: false,
      isTreeShown: true,
      masterSelectedRow: undefined, // 마스터에서 선택된 데이터
      selectedNodeDepth: 0
    }
  },
  watch: {
    selectedRow: function(newVal) {
      if (this.masterEvent) {
        this.$eventHub.$emit(this.masterEvent, {
          name: 'masterRowSelected',
          selectedRow: this.selectedRow
        })
      }
    },
    selectedNode: function(newVal, oldVal) {
      let tree
      if (newVal && newVal.selected && newVal.selected.tree && !oldVal) {
        tree = newVal.selected.tree.model
      } else if (newVal && newVal.tree && !oldVal) {
        tree = newVal.tree.model
      }

      if (tree) {
        this.initRows = window.copyObject(tree)
      } else if (!newVal) {
        this.initRows = undefined
      }
      if (!newVal || !newVal.selected || newVal.selected.length === 0) {
        return
      }
      $(this.$el)
        .find('.content')
        .css('opacity', '0')
      $(this.$el)
        .find('.content')
        .stop(true, true)
        .animate(
          {
            opacity: 1
          },
          400
        )
    },
    updateTargetNode: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.updateTitles(newVal)
        }
      },
      deep: true
    }
  },
  mounted: function() {
    if (this.masterEvent) {
      this.$eventHub.$on(this.masterEvent, this.onMasterEvent)
    }
    if (this.slaveEvent) {
      this.$eventHub.$on(this.slaveEvent, this.onSlaveEvent)
    }
    if (!this.slaveEvent) {
      this.load()
    }
    this.$forceUpdate()
  },
  beforeDestroy: function() {
    if (this.masterEvent) {
      this.$eventHub.$off(this.masterEvent, this.onMasterEvent)
    }
    if (this.slaveEvent) {
      this.$eventHub.$off(this.slaveEvent, this.onSlaveEvent)
    }
  },
  methods: {
    onNodeSelected(node) {
      this.updateTargetNode = undefined
      this.$nextTick(() => {
        if (node && node.data) {
          this.updateTargetNode = node.data.updatableTreeData
          this.selectedNodeDepth = 0
          let tmpNode = node
          while (tmpNode) {
            this.selectedNodeDepth++
            tmpNode = tmpNode.parent
          }
        }
      })
    },
    async updateConfirm() {
      window._eventHub.$emit('showLoading')
      if (await this.validationCheck()) {
        this.showModal('updateConfirmModalRef')
      } else {
        window._eventHub.$emit('hideLoading')
      }
    },
    update() {
      const updatedRows = this.getUpdatedRows(this.getSelected().tree.model)
      let updateTreeUrl
      if (this.updateTreeUrl) {
        updateTreeUrl = this.updateTreeUrl
      } else {
        updateTreeUrl =
          this.module + '/manage/updateTree/' + this.item.toCamelCase()
      }

      if (updateTreeUrl.indexOf('?') >= 0) {
        updateTreeUrl += '&'
      } else {
        updateTreeUrl += '?'
      }
      updateTreeUrl += this.getMenuAliasQuery() + '&'
      this.$axios
        .$put(
          updateTreeUrl,
          {
            updatedRows: updatedRows,
            deletedRows: this.deletedRows
          },
          { dont_hide_processing: true }
        )
        .then(response => {
          this.isBusy = false
          if (response.resultCode === 'success') {
            const data = response.data
            if (data && data.charsts) {
              for (let i = 0; i < data.charsts.length; i++) {
                let locale = data.charsts[i].locale
                if (locale && locale.locale) {
                  locale = locale.locale
                }
                this.setI18nMessage(
                  locale,
                  data.charsts[i].code,
                  data.charsts[i].charst
                )
              }
            }

            this.$toast.info(this.$t(response.message, response.params))
            this.load()
            this.$emit('updated', updatedRows)
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    },
    preprocessRow(row) {
      const retRow = window.copyObject(row)
      for (let i = this.updateColumns.length - 1; i >= 0; i--) {
        if (this.updateColumns[i].inputControl.type === 'multiselect') {
          const key = this.updateColumns[i].key
          const values = []
          for (let j = 0; j < retRow[key].length; j++) {
            values.push(retRow[key][j].value)
          }
          retRow[key] = values
        }
      }
      return retRow
    },
    toggleTree() {
      this.isTreeShown = !this.isTreeShown
      this.$forceUpdate()
    },
    getUpdatedRows(rows) {
      const retRows = []
      if (rows) {
        for (let i = 0; i < rows.length; i++) {
          const retRow = this.preprocessRow(rows[i].data.updatableTreeData)
          if (rows[i].children && rows[i].children.length > 0) {
            retRow.children = this.getUpdatedRows(rows[i].children)
          }
          retRows.push(retRow)
        }
      }
      return retRows
    },
    updateTitles(item) {
      let columns
      if (this.isNewInserted(item)) {
        columns = this.insertColumns
      } else {
        columns = this.updateColumns
      }
      for (let i = 0; i < columns.length; i++) {
        const column = columns[i]
        const key = columns[i].key
        if (
          column.list &&
          (column.list.treeNodeTitle || column.list.treeNodeSubtitle)
        ) {
          const value = this.translateTitle(column, item, key)
          if (column.list.treeNodeTitle) {
            this.getSelectedFirstNode().text = value
          } else {
            this.getSelectedFirstNode().data._subtitle = value
          }
        }
      }
    },
    getSelected() {
      if (!this.selectedNode) {
        return undefined
      }
      if (this.selectedNode.selected) {
        return this.selectedNode.selected
      }
      return this.selectedNode
    },
    getSelectedFirstNode() {
      if (this.getSelected()) {
        return this.getSelected()[0]
      }
    },
    translateTitle(column, item, key) {
      let value
      if (
        column.common &&
        column.common.textInfos &&
        column.common.textInfos.length > 0
      ) {
        let found = false
        for (let j = 0; j < item[key].length; j++) {
          if (
            item[key][j].locale &&
            item[key][j].locale.locale === this.$store.state.locale
          ) {
            value = item[key][j].charst
            found = true
            break
          }
        }
        if (!found) {
          value = item[key]
        }
      } else {
        value = item[key]
      }
      return value
    },
    deleteRows() {
      if (this.selectedNode && this.selectedNode.checked) {
        for (let i = 0; i < this.selectedNode.checked.length; i++) {
          const item = this.selectedNode.checked[i]
          if (
            this.getSelected() &&
            this.getSelected().length > 0 &&
            item === this.getSelectedFirstNode()
          ) {
            this.getSelectedFirstNode().unselect()
          }
          if (item && !this.isNewInserted(item.data.updatableTreeData)) {
            this.deletedRows.push(item.data.updatableTreeData)
          }
          this.$refs.tree.remove(item)
        }
      }
      this.$forceUpdate()
    },
    addChild($event, parent) {
      $event.preventDefault()
      $event.stopPropagation()

      const item = this.initInsertRow(this.insertColumns)
      const updatableTreeData = this.convertToUpdatable(
        window.copyObject(item),
        this.insertColumns
      )
      const treeData = window.copyObject(item)
      let newNode
      if (parent) {
        newNode = parent.append({
          text: '',
          data: { treeData: treeData, updatableTreeData: updatableTreeData }
        })
        parent.expand()
      } else {
        newNode = this.$refs.tree.append({
          text: '',
          data: { treeData: treeData, updatableTreeData: updatableTreeData }
        })
      }
      newNode.select()
      /*
      this.updateTargetNode = undefined
      this.$nextTick(() => {
        if (
          this.selectedNode &&
          this.getSelected() &&
          this.getSelected().length > 0 &&
          this.getSelectedFirstNode().data
        ) {
          this.updateTargetNode = this.getSelectedFirstNode().data.updatableTreeData
        }
      })
      */
    },
    isUpdatable() {
      if (!this.selectedNode || !this.getSelected()) {
        return false
      }
      return !this.isTreeNodeEquals(
        this.initRows,
        this.getSelected().tree.model
      )
    },
    reload: function() {
      if (this.isUpdatable()) {
        this.showModal('exitUpdateConfirmModalRef')
      } else {
        this.load()
      }
    },
    async validationCheck() {
      if (
        !this.selectedNode ||
        !this.getSelected() ||
        !this.getSelected().tree ||
        !this.getSelected().tree.model
      ) {
        return false
      }
      if (!(await this.validateList(this.getSelected().tree.model))) {
        return false
      }
      return true
    },
    async validateList(list) {
      for (let i = 0; i < list.length; i++) {
        if (
          !(await this.validateRow(list[i].data.updatableTreeData, list[i]))
        ) {
          return false
        }
        if (list[i].children && list[i].children.length > 0) {
          if (!(await this.validateList(list[i].children))) {
            return false
          }
        }
      }
      return true
    },
    expandParent(node) {
      if (node.parent) {
        node.parent.expand()
        if (node.parent.parent) {
          this.expandParent(node.parent)
        }
      }
    },
    async validateRow(row, node) {
      let columns
      if (this.isNewInserted(row)) {
        columns = this.insertColumns
      } else {
        columns = this.updateColumns
      }
      for (let i = 0; i < columns.length; i++) {
        for (const key in row) {
          if (key === columns[i].key) {
            if (
              !(await this.validateField(
                columns[i],
                row[key],
                row,
                node.data.treeData
              ))
            ) {
              node.select()
              this.expandParent(node)
              return false
            }
          }
        }
      }
      if (this.infos.additionalFieldInfoData) {
        const additionalFieldInfoData = this.infos.additionalFieldInfoData
        const additionalFieldInfos =
          additionalFieldInfoData.additionalFieldInfos
        for (let i = 0; i < additionalFieldInfos.length; i++) {
          const additionalFieldInfo = additionalFieldInfos[i]
          for (let j = 0; j < additionalFieldInfo.data.length; j++) {
            const datum = additionalFieldInfo.data[j]

            if (this.isVisible(datum, additionalFieldInfo, row)) {
              let rules = ''
              if (datum.essntlFlag === 'Y') {
                rules = 'required'
              }
              const ownerModel = additionalFieldInfo.ownerModel
              const result = await this.$validator.verify(
                row.additionalFieldData[ownerModel][datum.id],
                rules
              )
              if (!result.valid) {
                for (const key in result.failedRules) {
                  const msg = result.failedRules[key]
                    .split('validation.attribute.{field}')
                    .join(
                      this.$t(
                        ownerModel.toSnakeCase() +
                          '_adit_field_info.nm.' +
                          datum.id
                      )
                    )
                  this.$toast.error(msg)
                }
                node.select()
                this.expandParent(node)
                return false
              }
            }
          }
        }
      }
      return true
    },
    isVisible(datum, additionalFieldInfo, row) {
      if (!row) {
        return false
      }
      if (additionalFieldInfo.visibleType === 'always') {
        return true
      }
      if (additionalFieldInfo.visibleType === 'none') {
        return false
      }
      let visible = false
      let val = row
      const ownerData = additionalFieldInfo.ownerData
      const visibleBys = additionalFieldInfo.visibleBy
      for (let i = 0; i < ownerData.length; i++) {
        if (datum.objectId !== ownerData[i].id) {
          continue
        }
        if (additionalFieldInfo.visibleType === 'simple') {
          let allMatched = true
          for (let j = 0; j < visibleBys.length; j++) {
            val = row

            if (typeof val === 'object') {
              if (visibleBys[j].fieldName.indexOf('.') > 0) {
                const fieldNames = visibleBys[j].fieldName.split('.')
                val = val[fieldNames[0]]
                if (val[fieldNames[1]]) {
                  val = val[fieldNames[1]]
                  if (fieldNames.length > 2 && val[fieldNames[2]]) {
                    val = val[fieldNames[2]]
                  }
                }
              } else {
                val = val[visibleBys[j].fieldName]
              }
            }
            if (
              !this.isSimpleMatched(
                val,
                ownerData[i],
                visibleBys[j].fieldNameInOwnerModel,
                visibleBys[j].value
              )
            ) {
              allMatched = false
            }
          }
          if (allMatched) {
            visible = true
            break
          }
        } else {
          visible = true
        }
      }
      return visible
    },
    isSimpleMatched(value, ownerData, fieldName1, fieldName2) {
      if (!value) {
        return false
      }
      if (!fieldName2) {
        fieldName2 = fieldName1
      }
      if (Array.isArray(value) && value && value.length > 0) {
        for (let i = 0; i < value.length; i++) {
          let comp1 = value[i]
          let comp2 = ownerData

          const fieldName2Keys = fieldName2.split('.')
          for (let i = 0; i < fieldName2Keys.length; i++) {
            comp1 = comp1[fieldName2Keys[i]]
            if (comp1 === undefined || comp1 === null) {
              return false
            }
          }
          const fieldName1Keys = fieldName1.split('.')
          for (let i = 0; i < fieldName1Keys.length; i++) {
            comp2 = comp2[fieldName1Keys[i]]
            if (comp2 === undefined || comp2 === null) {
              return false
            }
          }

          if (
            comp1 !== undefined &&
            comp2 !== undefined &&
            comp1 !== null &&
            comp2 !== null &&
            comp1 === comp2
          ) {
            return true
          }
        }
        return false
      }
      if (typeof value === 'object') {
        return value[fieldName2] === ownerData[fieldName1]
      }
      return value === ownerData[fieldName1]
    },
    async validateField(column, value, inputRow, originalRow) {
      const result = await this.$validator.verify(
        value,
        this.getValidationRulesObject(column, this.module, this.item, inputRow)
      )
      let validated = true
      if (!result.valid) {
        for (const key in result.failedRules) {
          if (
            !(
              key === 'unique' &&
              !this.isNewInserted(inputRow) &&
              inputRow[column.key] === originalRow[column.key]
            )
          ) {
            const msg = result.failedRules[key]
              .split('validation.attribute.{field}')
              .join(column.label)
            this.$toast.error(column.label + ' : ' + msg)
            validated = false
          }
        }
      }
      return validated
    },
    isTreeNodeEquals(a, b) {
      if (a === undefined || a === null) {
        if (b === undefined || b === null) {
          return true
        }
        return false
      }
      if (b === undefined || b === null) {
        return false
      }
      if (a.length !== b.length) {
        return false
      }
      for (let i = 0; i < a.length; i++) {
        if (
          !window.isObjectEquals(
            window.copyObjectWithoutOriginalData(a[i].data.updatableTreeData),
            window.copyObjectWithoutOriginalData(b[i].data.updatableTreeData)
          )
        ) {
          return false
        }
        if (!this.isTreeNodeEquals(a[i].children, b[i].children)) {
          return false
        }
      }
      return true
    },
    getKeys(item) {
      if (!item) {
        return
      }
      const keys = {}
      for (let i = 0; i < this.keyColumns.length; i++) {
        const keyColumn = this.keyColumns[i]
        if (item[keyColumn.key]) {
          keys[keyColumn.key] = item[keyColumn.key]
        }
      }
      return keys
    },
    isNewInserted(item) {
      if (!item) {
        return false
      }
      const keys = this.getKeys(item)
      return Object.entries(keys).length <= 0
    },
    onMasterEvent(event) {
      if (event.name === 'slaveModeChanged') {
        this.onSlaveModeChanged(event.mode)
      }
    },
    onSlaveEvent(event) {
      if (event.name === 'masterRowSelected') {
        this.onMasterRowSelected(event.selectedRow)
      }
    },
    onMasterRowSelected(item) {
      this.scrollToMe = false
      if (!this.masterSelectedRow && item) {
        this.scrollToMe = true
      }
      this.masterSelectedRow = item
      if (this.masterSelectedRow) {
        this.load()
      } else {
        this.$forceUpdate()
      }
    },
    onSlaveModeChanged(slaveMode) {
      this.slaveMode = slaveMode
      this.$forceUpdate()
    },
    onRefreshStrings() {
      this.draw()
      this.$forceUpdate()
    },
    onDragFinish(param) {
      this.$forceUpdate()
    },
    draw: function() {
      if (!this.lastResponse) return
      const response = window.copyObject(this.lastResponse)
      const rows = response.data.treeData
      this.totalColumns = response.data.columns
      this.totalLoadedColumns = window.copyObject(response.data.columns)
      this.makeLabels(this.totalColumns)
      this.insertColumns = window.copyObject(this.totalColumns)
      this.updateColumns = window.copyObject(this.totalColumns)

      for (const key in response.data.infos.charsts) {
        const charsts = response.data.infos.charsts[key]
        for (let i = 0; i < charsts.length; i++) {
          const charst = charsts[i]
          this.setI18nMessage(charst.locale.locale, charst.code, charst.charst)
        }
      }

      if (this.hasAuthority('delete_' + this.item)) {
        this.deletable = !!response.data.infos.deletable
      } else {
        this.deletable = false
      }

      if (this.hasAuthority('update_' + this.item)) {
        this.orderable = !!response.data.infos.orderable
      } else {
        this.orderable = false
      }

      this.checkable = this.deletable
      this.updatable = !!response.data.infos.updatable
      this.infos = response.data.infos
      const childrenColumnKeys = []
      let parentColumnKey
      this.keyColumns = []
      if (this.totalColumns.length > 0) {
        for (let i = this.totalColumns.length - 1; i >= 0; i--) {
          if (this.totalColumns[i].primary) {
            this.keyColumns.push(this.totalColumns[i])
          }
          if (this.totalColumns[i].children) {
            childrenColumnKeys.push(this.totalColumns[i])
          }
          if (this.totalColumns[i].parentId) {
            parentColumnKey = this.totalColumns[i].key
          }
        }
      }
      if (this.insertColumns.length > 0) {
        for (let i = this.insertColumns.length - 1; i >= 0; i--) {
          if (!this.insertColumns[i].insert) {
            this.insertColumns.splice(i, 1)
            continue
          }
        }
      }
      if (this.updateColumns.length > 0) {
        for (let i = this.updateColumns.length - 1; i >= 0; i--) {
          if (!this.updateColumns[i].update) {
            this.updateColumns.splice(i, 1)
            continue
          }
        }
      }
      this.rows = []
      if (rows) {
        for (let i = 0; i < rows.length; i++) {
          this.rows.push(
            this.updateToReadable(
              rows[i],
              this.totalColumns,
              childrenColumnKeys,
              parentColumnKey
            )
          )
        }
      }
      this.treeOptions = {
        checkbox: this.checkable,
        parentSelect: false,
        autoCheckChildren: false,
        filter: {
          emptyText: this.$t('common.notification.no_data'),
          matcher(query, node) {
            let title = node.text
            if (node.data && node.data._subtitle) {
              title += node.data._subtitle
            }
            return new RegExp(query, 'i').test(title)
          }
        },
        dnd: this.orderable
      }
    },
    convertToUpdatable(srcItem, columns) {
      let item = window.copyObject(srcItem)
      if (this.infos && this.infos.charsts) {
        for (let i = 0; i < this.infos.charsts.length; i++) {
          this.setI18nMessage(
            this.infos.charsts[i].locale.locale,
            this.infos.charsts[i].code,
            this.infos.charsts[i].charst
          )
        }
      }
      if (columns.length > 0) {
        item = this.updateUpdateColumns(item, columns, this.infos, true)
      }

      if (this.slaveEvent) {
        for (let i = 0; i < this.totalLoadedColumns.length; i++) {
          const column = this.totalLoadedColumns[i]
          if (column.common && column.common.masterKey) {
            item[column.key] = this.masterSelectedRow
          }
        }
      }
      return item
    },
    updateToReadable: function(
      treeDatumSrc,
      columns,
      childrenColumnKeys,
      parentColumnKey
    ) {
      const updatableTreeData = this.convertToUpdatable(
        window.copyObject(treeDatumSrc),
        columns
      )
      const treeDatumCopied = window.copyObject(treeDatumSrc)
      for (let i = 0; i < childrenColumnKeys.length; i++) {
        delete treeDatumCopied[childrenColumnKeys[i].key]
        delete updatableTreeData[childrenColumnKeys[i].key]
      }
      for (let j = 0; j < columns.length; j++) {
        const key = columns[j].key
        if (treeDatumCopied[key]) {
          if (key.endsWith('Code')) {
            for (
              let k = 0;
              k < columns[j].inputControl.candidate.options.length;
              k++
            ) {
              const option = columns[j].inputControl.candidate.options[k]
              if (treeDatumCopied[key] === option.value) {
                treeDatumCopied[key] = this.$t(option.texts[0].value)
              }
            }
          }
          if (
            columns[j].inputControl &&
            columns[j].inputControl.type === 'map' &&
            treeDatumCopied[key]
          ) {
            treeDatumCopied[key] = JSON.parse(treeDatumCopied[key])
          } else if (
            columns[j].inputControl &&
            columns[j].inputControl.type === 'datetime'
          ) {
            treeDatumCopied[key] = this.$moment(treeDatumCopied[key]).format(
              this.$t('common.format.datetime')
            )
          } else if (
            columns[j].inputControl &&
            columns[j].inputControl.type === 'time'
          ) {
            treeDatumCopied[key] = this.$moment(treeDatumCopied[key]).format(
              this.$t('common.format.time')
            )
          } else if (
            columns[j].inputControl &&
            columns[j].inputControl.type === 'date'
          ) {
            treeDatumCopied[key] = this.$moment(treeDatumCopied[key]).format(
              this.$t('common.format.date')
            )
          } else if (key.endsWith('Dt')) {
            treeDatumCopied[key] = this.$moment(treeDatumCopied[key]).format(
              this.$t('common.format.datetime')
            )
          } else if (
            key.endsWith('De') ||
            key.endsWith('Bgnde') ||
            key.endsWith('Endde')
          ) {
            treeDatumCopied[key] = this.$moment(treeDatumCopied[key]).format(
              this.$t('common.format.date')
            )
          }
        }

        if (
          columns[j].common &&
          columns[j].common.textInfos &&
          columns[j].common.textInfos.length > 0
        ) {
          treeDatumCopied[key] = this.getTextFromTextInfos(
            columns[j].common.textInfos,
            treeDatumCopied,
            key,
            columns[j].common.separatorTextInfos,
            columns[j].common.targetType,
            columns[j].common.noDataLabelTextCode
          ).stripTags()
          columns[j].isHtml = true
        }
      }

      let children
      if (
        childrenColumnKeys &&
        childrenColumnKeys.length > 0 &&
        treeDatumSrc[childrenColumnKeys[0].key] &&
        treeDatumSrc[childrenColumnKeys[0].key].length > 0
      ) {
        children = []
        for (
          let i = 0;
          i < treeDatumSrc[childrenColumnKeys[0].key].length;
          i++
        ) {
          children.push(
            this.updateToReadable(
              treeDatumSrc[childrenColumnKeys[0].key][i],
              columns,
              childrenColumnKeys,
              parentColumnKey
            )
          )
        }
      }
      return {
        data: {
          treeData: treeDatumCopied,
          updatableTreeData: updatableTreeData,
          _subtitle: this.getTitle(treeDatumCopied, columns, false)
        },
        children: children,
        text: this.getTitle(treeDatumCopied, columns, true),
        isRoot: !treeDatumCopied[parentColumnKey]
      }
    },
    getTitle(item, columns, isTitle) {
      let title
      for (let i = 0; i < columns.length; i++) {
        const column = columns[i]
        const key = columns[i].key
        if (column.list) {
          if (column.list.treeNodeTitle && isTitle) {
            title = this.translateTitle(column, item, key)
          } else if (column.list.treeNodeSubtitle && !isTitle) {
            title = this.translateTitle(column, item, key)
          }
        }
      }
      return title
    },
    load: function() {
      this.treeFilter = ''
      this.isBusy = true
      this.selectedNode = undefined
      this.deletedRows = []
      let treeUrl
      if (this.treeUrl) {
        treeUrl = this.treeUrl
      } else {
        treeUrl = this.module + '/manage/tree/' + this.item.toCamelCase()
      }
      if (treeUrl.indexOf('?') >= 0) {
        treeUrl += '&'
      } else {
        treeUrl += '?'
      }
      treeUrl += this.getMenuAliasQuery() + '&'
      this.$axios
        .$post(treeUrl, {
          masterSelectedRow: this.masterSelectedRow
        })
        .then(response => {
          this.isBusy = false
          if (response.resultCode === 'success') {
            this.lastResponse = response
            this.draw(response)
            if (this.scrollToMe) {
              this.$nextTick(() => {
                $('.app-body').animate(
                  {
                    scrollTop:
                      $(this.$el).offset().top -
                      55 +
                      $('.app-body').scrollTop() +
                      'px'
                  },
                  'ease-in'
                )
              })
              this.scrollToMe = false
            }
            this.$forceUpdate()
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
        .catch(() => {
          this.isBusy = false
        })
    }
  }
}
</script>

<style scoped>
.tree-container {
  position: relative;
  overflow-x: hidden;
}
>>> ul.tree-root {
  padding-bottom: 100px;
}
.disable-list-background {
  background-color: rgba(0, 0, 0, 0.8);
  text-align: center;
  padding-top: 50px;
  color: white;
  z-index: 2;
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
}
.disable-list-background.disabled {
  display: block;
}
.navigation {
  position: absolute;
  left: 0;
  top: 46px;
  bottom: 0;
  width: 280px;
  overflow-y: auto;
  background-color: #f9f9f9;
  border-right: 1px solid #dddddd;
}

.navigation-filter {
  padding: 5px 10px;
}

.navigation-filter input {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid;
  border-color: #d2d2d2;
  border-radius: 3px;
  padding: 6px;
  box-sizing: border-box;
}

.content {
  overflow: auto;
  position: absolute;
  left: 280px;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  padding-top: 60px;
}

.button-area {
  margin-top: 10px;
  margin-bottom: 5px;
}
.text.inactive {
  color: #bbbbbb;
}
.tree-scope .text {
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tree-scope .subtitle {
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.inactive-badge {
  font-size: 1rem;
}
.tree-arrow.has-child:after {
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAAmJLR0QA/4ePzL8AAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBBQOCQ0YTpzfAAAAjklEQVQoz2NmYGBgYGAIdAw/LPHu6kUGDMAEoXjt+WXM5kck4VTAwMDAwMhoOgdTCRMyB5sSJlQuphImdCPRlTBhOgtVCRYFECWBjngUMDAwMDAy4VVwJnvdXjwKTmcvn47HDadzlk/D44szecun4gmHM/nLJuMJyTMFyyahm8gCoT4f+fz8ZtuyKZguAgDLtyS94NiAKwAAAABJRU5ErkJggg==');
  border: 0;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  transform: rotate(0deg) translateY(-50%) translateX(-2px);
}
>>> .tree .tree-filter-empty {
  text-align: center;
  padding: 50px 0;
}
>>> .matched {
  background-color: rgba(255, 208, 45, 0.45);
}
.tree-arrow.expanded.has-child:after {
  transform: rotate(90deg) translateY(0%) translateX(-8px);
}

.tree-node.selected > .tree-content {
  background: #398df0;
}

.tree-node.selected > .tree-content > .tree-anchor {
  color: #fff;
}

.tree-content {
  padding: 2px 0;
}
.tree-scope {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.subtitle {
  color: #a9a9a9;
}
.tree-form {
  height: 500px;
  margin-top: 30px;
}
.content-inner {
  height: 100%;
  width: 100%;
}
.card-header {
  z-index: 5;
}
>>> .tree-node > .tree-content {
  transition: all 0.3s ease-in-out;
}
>>> .tree-node > .tree-content:hover {
  background-color: #ddefef;
}
.close-tree-button {
  display: none;
}
.open-tree-button {
  display: none;
}

.no-show-tree .navigation,
.no-show-tree .content {
  transition: all 0.4s ease-in-out;
  opacity: 1;
}
@media (max-width: 575px) {
  .open-tree-button {
    float: right;
    margin: -7px;
    display: block;
  }
  .close-tree-button {
    display: block;
    float: right;
  }
  .show-tree .open-tree-button {
    display: none;
  }
  .no-show-tree .navigation {
    width: 0;
    margin-left: -1px;
    opacity: 0;
  }
  .no-show-tree .content {
    left: 0;
  }
}
</style>
